<div class="wrapper">
    <!-- <app-appli-side-bar [sidebars]="sidebar" (clickEventIndex)="setClickIndex($event)"></app-appli-side-bar> -->
    <app-appli-side-bar [sidebars]="sidebar" (focusEventIndex)="setFocusIndex($event)" (clickEventIndex)="setClickIndex($event)"></app-appli-side-bar>

    <div class="icon_box">
        <div class="top_icon"></div>
        <div class="app_name">{{ appname }}</div>

    </div>
    <div class="main_content_wrapper">
        <div class="main_content">

            <div class="VideoWindow" [ngClass]="{'FullScreen':FullScreen}">
                <video width="100%" autoplay muted id="myvideo" preload="none" #movie>
                    <source src="" />
                </video>
            </div>

            <div class="remark">
                <ng-container *ngIf="lang !='eng'">
                    「決定」ボタンでフルスクリーンの切り替えができます。
                </ng-container>
                <ng-container *ngIf="lang ==='eng'">
                    The center button toggles between full screen.
                </ng-container>

            </div>

        </div>

    </div>
</div>